module.exports = __webpack_public_path__ + "img/16_en.27b3a021.png";